import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'

async function fetchActualities (cityId, token, {from = 0, number = 10, includeDrafts = false, includeScheduled = false, excludeContent = false} = {})
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'actualities')
    const response = await axios.get(url, { params: { from, number, includeDrafts, includeScheduled, excludeContent }, headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function fetchActualityById (cityId, actualityId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'actualities', actualityId.toString())
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function postActuality (actuality, cityId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'actualities')
    const response = await axios.post(url, actuality, { headers: { Authorization: `Bearer ${token}` } })


    return response.data
}

async function updateActuality (actualityId, actuality, cityId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'actualities', actualityId.toString())
    const response = await axios.patch(url, actuality, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function deleteActuality (actualityId, cityId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'actualities', actualityId.toString())
    const response = await axios.delete(url, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

export default { fetchActualities, fetchActualityById, postActuality, updateActuality, deleteActuality }


// WEBPACK FOOTER //
// ./src/services/actualities.js